import { MenuProps } from "@mui/material";
import { MouseEvent, useCallback, useState } from "react";

interface IMenuState {
    open: (event: MouseEvent<HTMLElement>) => void;
    close: () => void;
    menuProps: Pick<MenuProps, "anchorEl" | "open" | "onClose">;
}

export const useMenuState = (): IMenuState => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const open = useCallback(({ currentTarget }: MouseEvent<HTMLElement>) => {
        setAnchorEl(currentTarget);
    }, []);

    const close = useCallback(() => {
        setAnchorEl(null);
    }, []);

    return {
        open,
        close,
        menuProps: {
            anchorEl,
            open: !!anchorEl,
            onClose: close,
        },
    };
};
